<template>
    <el-dialog v-dialogDrag class="dialog" width="1100px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑实际支付登记
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading" label-width="120px"
                     :inline="true" style="text-align: left;padding-left:10px;">

                <div>
                    <el-form-item label="计划编号">
                        <el-input style="width:200px" v-model="form.billNo"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="项目名称">
                        <el-input style="width:200px" v-model="form.projectName"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="客户">
                        <el-input style="width:200px" v-model="form.customerName"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="业务员">
                        <el-input style="width:200px" v-model="form.salesMan"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号">
                        <el-input style="width:200px" v-model="form.relaBillNo"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="订单金额">
                        <el-input style="width:200px" v-model="form.taxTotal"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="支付条件">
                        <el-input style="width:200px" v-model="form.payCondition"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="支付节点" required>
                        <el-input style="width:200px" v-model="form.payNodes"
                                  placeholder="选择支付节点" @click.native="selPlan"
                                  readonly></el-input>
                    </el-form-item>
                    <el-form-item label="支付比例%">
                        <el-input style="width:200px" v-model="form.payRate"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="预计支付金额">
                        <el-input style="width:200px" v-model="form.payTotal"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="预计支付日期">
                        <el-input style="width:200px" v-model="form.planPayDate"
                                  placeholder="选择支付节点后自动赋值" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="会计科目" required>
                        <el-input style="width:200px" v-model="form.accTitleName" placeholder="选择会计科目"
                                  readonly
                                  @click.native="clickAccTitle">
                        </el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="实际支付金额" required>
                        <el-input style="width:200px" v-model="form.payedTotal"
                                  placeholder="请输入实际支付金额"></el-input>
                    </el-form-item>
                    <el-form-item label="实际支付日期" required>
                        <el-date-picker type="date" placeholder="请选择实际支付日期"
                                        style="width: 200px"
                                        value-format="yyyy-MM-dd"
                                        v-model="form.payedDate"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="附件">
                        <div style="padding: 2px 1px; width: 200px;">
                            <el-button type="primary" size="medium" icon="el-icon-upload"
                                       @click="uploadFile">上传
                            </el-button>
                            <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile">查看
                            </el-button>
                        </div>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="备注">
                        <el-input style="width:200px" v-model="form.remark" placeholder="请输入备注">
                        </el-input>
                    </el-form-item>
                </div>

            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>

            <fileupload v-if="showFileUpload"
                        :fileUrl="fileUrl"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        :delFileUrl="delFileUrl"
                        :fileKey="fileKey"
                        @closeDialog="closeDialog">
            </fileupload>
            <fileDialog v-if="showFileDialog"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        @closeDialog="closeDialog">
            </fileDialog>
            <selPlan v-if="showPlan"
                        :billProId="billProId"
                        @closeDialog="closeDialog"
                        @checkRow="checkPlan">
            </selPlan>
            <selAccTitle v-if="showAccTitle"
                         :accTitleData="accTitleData"
                         @closeDialog="closeDialog"
                         @checkRow="checkAccTitle">
            </selAccTitle>
        </div>
    </el-dialog>
</template>

<script>

    import fileupload from '@/components/tools/fileupload/dialog'
    import fileDialog from '@/components/tools/fileupload/showDialog'
    import selPlan from '@/components/page/finance/collectionplan/selCollectPlan'
    import selAccTitle from '@/components/page/finance/accountingtitle/selAccTitlePay'


    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {
            fileupload,
            fileDialog,
            selPlan,
            selAccTitle
        },
        data() {
            return {
                accTitleData: {},
                dialoading: this.loading,
                showPlan: false,
                billProId: "",
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                showAccTitle: false,
                formLabelWidth: '80px',

                fileUrl: "/billfile/uploadFiles",
                fileListUrl: "/billfile/getBillFile",
                delFileUrl: "/billfile/delete",
                fileKey: "billFileId",
                fileParam: {
                    billId: this.formData.billProId
                },
                showFileUpload: false,
                showFileDialog: false,
            };
        },
        methods: {

            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if(this.$pub.isEmpty(this.form.billProId)){
                    this.$message({message: '请选择支付计划', type: 'error'});
                    return false;
                }
                if(this.$pub.isEmpty(this.form.payedTotal)){
                    this.$message({message: '请输入实际支付金额', type: 'error'});
                    return false;
                }
                if(this.$pub.isEmpty(this.form.payedDate)){
                    this.$message({message: '请输入实际支付日期', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
            selPlan() {
                this.billProId = this.form.billProId;
                this.showPlan = true;
            },
            checkPlan(row) {
                this.form.billId = row.billId;
                this.form.billNo = row.billNo;
                this.form.billProId = row.billProId;
                this.form.relaBillNo = row.relaBillNo;
                this.form.customerName = row.customerName;
                this.form.customerId = row.customerId;
                this.form.salesMan = row.salesMan;
                this.form.projectId = row.projectId;
                this.form.projectName = row.projectName;
                this.form.payCondition = row.payCondition;
                this.form.payNodes = row.payNodes;
                this.form.payRate = row.payRate;
                this.form.payTotal = row.payTotal;
                this.form.planPayDate = row.planPayDate;
                this.showPlan = false;
            },
            checkAccTitle(row) {
                this.form.accTitleId = row.id
                this.form.accTitleName = row.name
                this.form.accTitleCode = row.code
                this.showAccTitle = false;
            },
            clickAccTitle() {
                this.accTitleData.accTitleId = this.form.id
                this.accTitleData.accTitleName = this.form.name
                this.accTitleData.accTitleCode = this.form.code
                this.showAccTitle = true;
            },
            closeDialog() {
                this.showFileUpload = false;
                this.showFileDialog = false;
                this.showPlan = false;
                this.showCustomer = false;
                this.showProject = false;
                this.showAccTitle = false;
            },
        }
    }
</script>